import React, {Component} from 'react';
import '../style.css';
import {PageHeader, Transfer, Space, Card, Button, message, Spin, Typography} from "antd";
import {fetchPost, fetchPostFile} from "../static/util/fetch";
const { Paragraph } = Typography;
class FinallyFile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            companyId:this.props.companyId,
            companyName:this.props.companyName,
            targetKeys1:[], selectedKeys1:[],
            targetKeys2:[], selectedKeys2:[],
            targetKeys3:[], selectedKeys3:[],
            targetKeys4:[], selectedKeys4:[],
            targetKeys5:[], selectedKeys5:[],
            targetKeys6:[], selectedKeys6:[],
            targetKeys7:[], selectedKeys7:[],
            targetKeys8:[], selectedKeys8:[],
            targetKeys9:[], selectedKeys9:[],
            targetKeys10:[], selectedKeys10:[],
            flag1:false, flag2:false, flag3:false, flag4:false, flag5:false, flag6:false, flag7:false, flag8:false, flag9:false, flag10:false,
            flag11:false, flag12:false, flag13:false, flag14:false, flag15:false, flag16:false, flag17:false, flag18:false, flag19:false, flag20:false,
            flag21:false, flag22:false, flag23:false, flag24:false, flag25:false, flag26:false, flag27:false, flag28:false, flag29:false, flag30:false,
            flag31:false, flag32:false, flag33:false, flag34:false, flag35:false, flag36:false, flag37:false, flag38:false, flag39:false, flag40:false,
            flag41:false, flag42:false, flag43:false, flag44:false, flag45:false, flag46:false,
            loading1:false,loading2:false,loading3:false,loading4:false,loading5:false,loading6:false,loading7:false,
            loading8:false,loading9:false,loading10:false,

        }
    }
    componentDidMount() {
        fetchPost(global.constants.checkExport,{companyId: this.state.companyId})
            .then(
                res => {
                    if(res.code === 200) {
                        this.setState(()=>({
                            flag1:res.data.parameter1,
                            flag2:res.data.parameter2,
                            flag3:res.data.parameter3,
                            flag4:res.data.parameter4,
                            flag5:res.data.parameter5,
                            flag6:res.data.parameter6,
                            flag7:res.data.parameter7,
                            flag8:res.data.parameter8,
                            flag9:res.data.parameter9,
                            flag10:res.data.parameter10,
                            flag11:res.data.parameter11,
                            flag12:res.data.parameter12,
                            flag13:res.data.parameter13,
                            flag14:res.data.parameter14,
                            flag15:res.data.parameter15,
                            flag16:res.data.parameter16,
                            flag17:res.data.parameter17,
                            flag18:res.data.parameter18,
                            flag19:res.data.parameter19,
                            flag20:res.data.parameter20,
                            flag21:res.data.parameter21,
                            flag22:res.data.parameter22,
                            flag23:res.data.parameter23,
                            flag24:res.data.parameter24,
                            flag25:res.data.parameter25,
                            flag26:res.data.parameter26,
                            flag27:res.data.parameter27,
                            flag28:res.data.parameter28,
                            flag29:res.data.parameter29,
                            flag30:res.data.parameter30,
                            flag31:res.data.parameter31,
                            flag32:res.data.parameter32,
                            flag33:res.data.parameter33,
                            flag34:res.data.parameter34,
                            flag35:res.data.parameter35,
                            flag36:res.data.parameter36,
                            flag37:res.data.parameter37,
                            flag38:res.data.parameter38,
                            flag39:res.data.parameter39,
                            flag40:res.data.parameter40,
                            flag41:res.data.parameter41,
                            flag42:res.data.parameter42,
                            flag43:res.data.parameter43,
                            flag44:res.data.parameter44,
                            flag45:res.data.parameter45,
                            flag46:res.data.parameter46,
                        }))
                    }
                }
            )
    }
    handleChange1 = (nextTargetKeys, direction, moveKeys)=>{
        this.setState({ targetKeys1: nextTargetKeys })
    }
    handleSelectChange1 = (sourceSelectedKeys, targetSelectedKeys) => {
        this.setState({ selectedKeys1: [...sourceSelectedKeys, ...targetSelectedKeys] });
    };
    handleChange2 = (nextTargetKeys, direction, moveKeys)=>{
        this.setState({ targetKeys2: nextTargetKeys })
    }
    handleSelectChange2 = (sourceSelectedKeys, targetSelectedKeys) => {
        this.setState({ selectedKeys2: [...targetSelectedKeys,...sourceSelectedKeys] });
    };
    handleChange3 = (nextTargetKeys, direction, moveKeys)=>{
        this.setState({ targetKeys3: nextTargetKeys })
    }
    handleSelectChange3 = (sourceSelectedKeys, targetSelectedKeys) => {
        this.setState({ selectedKeys3: [...sourceSelectedKeys, ...targetSelectedKeys] });
    };
    handleChange4 = (nextTargetKeys, direction, moveKeys)=>{
        this.setState({ targetKeys4: nextTargetKeys })
    }
    handleSelectChange4 = (sourceSelectedKeys, targetSelectedKeys) => {
        this.setState({ selectedKeys4: [...sourceSelectedKeys, ...targetSelectedKeys] });
    };
    handleChange5 = (nextTargetKeys, direction, moveKeys)=>{
        this.setState({ targetKeys5: nextTargetKeys })
    }
    handleSelectChange5 = (sourceSelectedKeys, targetSelectedKeys) => {
        this.setState({ selectedKeys5: [...sourceSelectedKeys, ...targetSelectedKeys] });
    };
    handleChange6 = (nextTargetKeys, direction, moveKeys)=>{
        this.setState({ targetKeys6: nextTargetKeys })
    }
    handleSelectChange6 = (sourceSelectedKeys, targetSelectedKeys) => {
        this.setState({ selectedKeys6: [...sourceSelectedKeys, ...targetSelectedKeys] });
    };
    handleChange7 = (nextTargetKeys, direction, moveKeys)=>{
        this.setState({ targetKeys7: nextTargetKeys })
    }
    handleSelectChange7 = (sourceSelectedKeys, targetSelectedKeys) => {
        this.setState({ selectedKeys7: [...sourceSelectedKeys, ...targetSelectedKeys] });
    };
    handleChange8 = (nextTargetKeys, direction, moveKeys)=>{
        this.setState({ targetKeys8: nextTargetKeys })
    }
    handleSelectChange8 = (sourceSelectedKeys, targetSelectedKeys) => {
        this.setState({ selectedKeys8: [...sourceSelectedKeys, ...targetSelectedKeys] });
    };
    handleChange9 = (nextTargetKeys, direction, moveKeys)=>{
        this.setState({ targetKeys9: nextTargetKeys })
    }
    handleSelectChange9 = (sourceSelectedKeys, targetSelectedKeys) => {
        this.setState({ selectedKeys9: [...sourceSelectedKeys, ...targetSelectedKeys] });
    };
    handleChange10 = (nextTargetKeys, direction, moveKeys)=>{
        this.setState({ targetKeys10: nextTargetKeys })
    }
    handleSelectChange10 = (sourceSelectedKeys, targetSelectedKeys) => {
        this.setState({ selectedKeys10: [...sourceSelectedKeys, ...targetSelectedKeys] });
    };
    handleExport1(){
        this.setState(()=>({
            loading1:true
        }))
        if(this.state.targetKeys1.length === 0){
            message.info("请先添加要合并生成的文件").then()
            this.setState(()=>({
                loading1:false
            }))
        }else{
            let params = {
                companyId:this.state.companyId,
                list:this.state.targetKeys1
            }
            fetchPostFile(global.constants.exportPDF, params)
                .then(
                    res=>{
                        res.blob().then(
                            blob=>{
                                let blobUrl = window.URL.createObjectURL(blob);
                                let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                                let filename = '2.资质证明.pdf';//设置文件名称
                                aElement.href = blobUrl;//设置a标签路径
                                aElement.download = filename;
                                aElement.click();
                                window.URL.revokeObjectURL(blobUrl);
                                this.setState(()=>({
                                    loading1:false
                                }))
                            }
                        )
                    }
                )
        }
    }
    handleExport2(){
        this.setState(()=>({
            loading2:true
        }))
        if(this.state.targetKeys2.length === 0){
            message.info("请先添加要合并生成的文件").then()
            this.setState(()=>({
                loading2:false
            }))
        }else{
            let params = {
                companyId:this.state.companyId,
                list:this.state.targetKeys2
            }
            fetchPostFile(global.constants.exportPDF, params)
                .then(
                    res=>{
                        res.blob().then(
                            blob=>{
                                let blobUrl = window.URL.createObjectURL(blob);
                                let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                                let filename = '3.知识产权.pdf';//设置文件名称
                                aElement.href = blobUrl;//设置a标签路径
                                aElement.download = filename;
                                aElement.click();
                                window.URL.revokeObjectURL(blobUrl);
                                this.setState(()=>({
                                    loading2:false
                                }))
                            }
                        )
                    }
                )
        }
    }
    handleExport3(){
        this.setState(()=>({
            loading3:true
        }))
        if(this.state.targetKeys3.length === 0){
            message.info("请先添加要合并生成的文件").then()
            this.setState(()=>({
                loading3:false
            }))
        }else{
            let params = {
                companyId:this.state.companyId,
                list:this.state.targetKeys3
            }
            fetchPostFile(global.constants.exportPDF, params)
                .then(
                    res=>{
                        res.blob().then(
                            blob=>{
                                let blobUrl = window.URL.createObjectURL(blob);
                                let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                                let filename = '4.审计报告.pdf';//设置文件名称
                                aElement.href = blobUrl;//设置a标签路径
                                aElement.download = filename;
                                aElement.click();
                                window.URL.revokeObjectURL(blobUrl);
                                this.setState(()=>({
                                    loading3:false
                                }))
                            }
                        )
                    }
                )
        }
    }
    handleExport4(){
        this.setState(()=>({
            loading4:true
        }))
        if(this.state.targetKeys4.length === 0){
            message.info("请先添加要合并生成的文件").then()
            this.setState(()=>({
                loading4:false
            }))
        }else{
            let params = {
                companyId:this.state.companyId,
                list:this.state.targetKeys4
            }
            fetchPostFile(global.constants.exportPDF, params)
                .then(
                    res=>{
                        res.blob().then(
                            blob=>{
                                let blobUrl = window.URL.createObjectURL(blob);
                                let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                                let filename = '5.成果转化.pdf';//设置文件名称
                                aElement.href = blobUrl;//设置a标签路径
                                aElement.download = filename;
                                aElement.click();
                                window.URL.revokeObjectURL(blobUrl);
                                this.setState(()=>({
                                    loading4:false
                                }))
                            }
                        )
                    }
                )
        }
    }
    handleExport5(){
        this.setState(()=>({
            loading5:true
        }))
        if(this.state.targetKeys5.length === 0){
            message.info("请先添加要合并生成的文件").then()
            this.setState(()=>({
                loading5:false
            }))
        }else{
            let params = {
                companyId:this.state.companyId,
                list:this.state.targetKeys5
            }
            fetchPostFile(global.constants.exportPDF, params)
                .then(
                    res=>{
                        res.blob().then(
                            blob=>{
                                let blobUrl = window.URL.createObjectURL(blob);
                                let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                                let filename = '6.立项.pdf';//设置文件名称
                                aElement.href = blobUrl;//设置a标签路径
                                aElement.download = filename;
                                aElement.click();
                                window.URL.revokeObjectURL(blobUrl);
                                this.setState(()=>({
                                    loading5:false
                                }))
                            }
                        )
                    }
                )
        }
    }
    handleExport6(){
        this.setState(()=>({
            loading6:true
        }))
        if(this.state.targetKeys6.length === 0){
            message.info("请先添加要合并生成的文件").then()
            this.setState(()=>({
                loading6:false
            }))
        }else{
            let params = {
                companyId:this.state.companyId,
                list:this.state.targetKeys6
            }
            fetchPostFile(global.constants.exportPDF, params)
                .then(
                    res=>{
                        res.blob().then(
                            blob=>{
                                let blobUrl = window.URL.createObjectURL(blob);
                                let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                                let filename = '7.人员.pdf';//设置文件名称
                                aElement.href = blobUrl;//设置a标签路径
                                aElement.download = filename;
                                aElement.click();
                                window.URL.revokeObjectURL(blobUrl);
                                this.setState(()=>({
                                    loading6:false
                                }))
                            }
                        )
                    }
                )
        }
    }
    handleExport7(){
        this.setState(()=>({
            loading7:true
        }))
        if(this.state.targetKeys7.length === 0){
            message.info("请先添加要合并生成的文件").then()
            this.setState(()=>({
                loading7:false
            }))
        }else{
            let params = {
                companyId:this.state.companyId,
                list:this.state.targetKeys7
            }
            fetchPostFile(global.constants.exportPDF, params)
                .then(
                    res=>{
                        res.blob().then(
                            blob=>{
                                let blobUrl = window.URL.createObjectURL(blob);
                                let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                                let filename = '8.高品.pdf';//设置文件名称
                                aElement.href = blobUrl;//设置a标签路径
                                aElement.download = filename;
                                aElement.click();
                                window.URL.revokeObjectURL(blobUrl);
                                this.setState(()=>({
                                    loading7:false
                                }))
                            }
                        )
                    }
                )
        }
    }
    handleExport8(){
        this.setState(()=>({
            loading8:true
        }))
        if(this.state.targetKeys8.length === 0){
            message.info("请先添加要合并生成的文件").then()
            this.setState(()=>({
                loading8:false
            }))
        }else{
            let params = {
                companyId:this.state.companyId,
                list:this.state.targetKeys8
            }
            fetchPostFile(global.constants.exportPDF, params)
                .then(
                    res=>{
                        res.blob().then(
                            blob=>{
                                let blobUrl = window.URL.createObjectURL(blob);
                                let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                                let filename = '9.组织管理.pdf';//设置文件名称
                                aElement.href = blobUrl;//设置a标签路径
                                aElement.download = filename;
                                aElement.click();
                                window.URL.revokeObjectURL(blobUrl);
                                this.setState(()=>({
                                    loading8:false
                                }))
                            }
                        )
                    }
                )
        }
    }
    handleExport9(){
        this.setState(()=>({
            loading9:true
        }))
        if(this.state.targetKeys9.length === 0){
            message.info("请先添加要合并生成的文件").then()
            this.setState(()=>({
                loading9:false
            }))
        }else{
            let params = {
                companyId:this.state.companyId,
                list:this.state.targetKeys9
            }
            fetchPostFile(global.constants.exportPDF, params)
                .then(
                    res=>{
                        res.blob().then(
                            blob=>{
                                let blobUrl = window.URL.createObjectURL(blob);
                                let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                                let filename = '10.荣誉资质.pdf';//设置文件名称
                                aElement.href = blobUrl;//设置a标签路径
                                aElement.download = filename;
                                aElement.click();
                                window.URL.revokeObjectURL(blobUrl);
                                this.setState(()=>({
                                    loading9:false
                                }))
                            }
                        )
                    }
                )
        }
    }
    handleExport10(){
        this.setState(()=>({
            loading10:true
        }))
        if(this.state.targetKeys10.length === 0){
            message.info("请先添加要合并生成的文件").then()
            this.setState(()=>({
                loading10:false
            }))
        }else{
            let params = {
                companyId:this.state.companyId,
                list:this.state.targetKeys10
            }
            fetchPostFile(global.constants.exportPDF, params)
                .then(
                    res=>{
                        res.blob().then(
                            blob=>{
                                let blobUrl = window.URL.createObjectURL(blob);
                                let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                                let filename = this.state.companyName+'.pdf';//设置文件名称
                                aElement.href = blobUrl;//设置a标签路径
                                aElement.download = filename;
                                aElement.click();
                                window.URL.revokeObjectURL(blobUrl);
                                this.setState(()=>({
                                    loading10:false
                                }))
                            }
                        )
                    }
                )
        }
    }
    render() {
        const Anchor = props => {
            return (
                <a {...props}>{props.children}</a>
            );
        };
        const sourceFile1 = []
        const sourceFile2 = []
        const sourceFile3 = []
        const sourceFile4 = []
        const sourceFile5 = []
        const sourceFile6 = []
        const sourceFile7 = []
        const sourceFile8 = []
        const sourceFile9 = []
        const sourceFile10 = []
        sourceFile1.push(
            {
                key:  '企业注册登记证件',
                title: '企业注册登记证件',
                description: '企业注册登记证件',
                disabled: !this.state.flag1,
            },
            {
                key:  '技术领域说明',
                title: '技术领域说明',
                description: '技术领域说明',
                disabled: !this.state.flag2,
            })
       sourceFile2.push(
            {
                key:  '知识产权未重复使用声明',
                title: '知识产权未重复使用声明',
                description: '知识产权未重复使用声明',
                disabled: !this.state.flag3,
            },
            {
                key:  '知识产权情况汇总表',
                title: '知识产权情况汇总表',
                description: '知识产权情况汇总表',
                disabled: !this.state.flag4,
            },
            {
                key:  '知识产权概况',
                title: '知识产权概况',
                description: '知识产权概况',
                disabled: !this.state.flag5,
            },
            {
                key:  '知识产权证明材料',
                title: '知识产权证明材料',
                description: '知识产权证明材料',
                disabled: !this.state.flag6,
            },
            {
                key:  '知识产权对主要产品（服务）在技术上发挥核心支持作用介绍',
                title: '知识产权对主要产品（服务）在技术上发挥核心支持作用介绍',
                description: '知识产权对主要产品（服务）在技术上发挥核心支持作用介绍',
                disabled: !this.state.flag7,
            },)
        sourceFile3.push(
            {
                key:  '研发费用专项审计报告',
                title: '研发费用专项审计报告',
                description: '研发费用专项审计报告',
                disabled: !this.state.flag8,
            },
            {
                key:  '高品专项审计报告',
                title: '高品专项审计报告',
                description: '高品专项审计报告',
                disabled: !this.state.flag9,
            },
            {
                key:  '财务审计报告',
                title: '财务审计报告',
                description: '财务审计报告',
                disabled: !this.state.flag10,
            },
            {
                key:  '纳税申报表',
                title: '纳税申报表',
                description: '纳税申报表',
                disabled: !this.state.flag11,
            },
            {
                key:  '中介证明',
                title: '中介证明',
                description: '中介证明',
                disabled: !this.state.flag12,
            },
            )
        sourceFile4.push(
            {
                key:  '近三年成果转化汇总表',
                title: '近三年成果转化汇总表',
                description: '近三年成果转化汇总表',
                disabled: !this.state.flag14,
            },
            {
                key:  '科技成果转化总体情况说明',
                title: '科技成果转化总体情况说明',
                description: '科技成果转化总体情况说明',
                disabled: !this.state.flag15,
            },
            {
                key:  '科技成果逐项说明',
                title: '科技成果逐项说明',
                description: '科技成果逐项说明',
                disabled: !this.state.flag16,
            },
            {
                key:  '成果转化证明材料',
                title: '成果转化证明材料',
                description: '成果转化证明材料',
                disabled: !this.state.flag17,
            },)
        sourceFile5.push(
            {
                key:  '项目立项汇总表',
                title: '项目立项汇总表',
                description: '项目立项汇总表',
                disabled: !this.state.flag18,
            },
            {
                key:  '立项材料',
                title: '立项材料',
                description: '立项材料',
                disabled: !this.state.flag19,
            },
            )
        sourceFile6.push(
            {
                key:  '人员情况表',
                title: '人员情况表',
                description: '人员情况表',
                disabled: !this.state.flag22,
            },
            {
                key:  '人员花名册',
                title: '人员花名册',
                description: '人员花名册',
                disabled: !this.state.flag23,
            },
            {
                key:  '人员结构表',
                title: '人员结构表',
                description: '人员结构表',
                disabled: !this.state.flag24,
            },
            {
                key:  '社保缴费证明',
                title: '社保缴费证明',
                description: '社保缴费证明',
                disabled: !this.state.flag25,
            },)
        sourceFile7.push(
            {
                key:  '高新技术产品关键技术和技术指标的具体说明',
                title: '高新技术产品关键技术和技术指标的具体说明',
                description: '高新技术产品关键技术和技术指标的具体说明',
                disabled: !this.state.flag26,
            },
            {
                key:  '高品证明材料',
                title: '高品证明材料',
                description: '高品证明材料',
                disabled: !this.state.flag27,
            },)
        sourceFile8.push(
            {
                key:  '企业研究开发组织管理水平总体情况说明',
                title: '企业研究开发组织管理水平总体情况说明',
                description: '企业研究开发组织管理水平总体情况说明',
                disabled: !this.state.flag28,
            },
            {
                key:  '企业研究开发组织管理水平指标逐项说明',
                title: '企业研究开发组织管理水平指标逐项说明',
                description: '企业研究开发组织管理水平指标逐项说明',
                disabled: !this.state.flag29,
            },
            {
                key:  '研发项目管理制度',
                title: '研发项目管理制度',
                description: '研发项目管理制度',
                disabled: !this.state.flag30,
            },
            {
                key:  '研发投入核算管理制度',
                title: '研发投入核算管理制度',
                description: '研发投入核算管理制度',
                disabled: !this.state.flag31,
            },
            {
                key:  '研发辅助账管理办法',
                title: '研发辅助账管理办法',
                description: '研发辅助账管理办法',
                disabled: !this.state.flag32,
            },
            {
                key:  '企业研发准备金管理制度',
                title: '企业研发准备金管理制度',
                description: '企业研发准备金管理制度',
                disabled: !this.state.flag33,
            },
            {
                key:  '成立研发中心的通知',
                title: '成立研发中心的通知',
                description: '成立研发中心的通知',
                disabled: !this.state.flag34,
            },
            {
                key:  '研发中心建设情况说明',
                title: '研发中心建设情况说明',
                description: '研发中心建设情况说明',
                disabled: !this.state.flag35,
            },
            {
                key:  '研发设备明细表',
                title: '研发设备明细表',
                description: '研发设备明细表',
                disabled: !this.state.flag36,
            },
            {
                key:  '产学研协议',
                title: '产学研协议',
                description: '产学研协议',
                disabled: !this.state.flag37,
            },
            {
                key:  '科技成果转化的组织实施与激励奖励制度',
                title: '科技成果转化的组织实施与激励奖励制度',
                description: '科技成果转化的组织实施与激励奖励制度',
                disabled: !this.state.flag38,
            },
            {
                key:  '开放式创新创业平台制度',
                title: '开放式创新创业平台制度',
                description: '开放式创新创业平台制度',
                disabled: !this.state.flag39,
            },
            {
                key:  '科技人员培训管理制度',
                title: '科技人员培训管理制度',
                description: '科技人员培训管理制度',
                disabled: !this.state.flag40,
            },
            {
                key:  '科技人员培养进修制度',
                title: '科技人员培养进修制度',
                description: '科技人员培养进修制度',
                disabled: !this.state.flag41,
            },
            {
                key:  '人才引进制度',
                title: '人才引进制度',
                description: '人才引进制度',
                disabled: !this.state.flag42,
            },
            {
                key:  '研发人员绩效考核制度',
                title: '研发人员绩效考核制度',
                description: '研发人员绩效考核制度',
                disabled: !this.state.flag43,
            },
            {
                key:  '研发设备照片',
                title: '研发设备照片',
                description: '研发设备照片',
                disabled: !this.state.flag44,
            },
            {
                key:  '研发费用辅助帐',
                title: '研发费用辅助帐',
                description: '研发费用辅助帐',
                disabled: !this.state.flag45,
            },)
       sourceFile9.push(
            {
                key:  '荣誉资质',
                title: '荣誉资质',
                description: '荣誉资质',
                disabled: !this.state.flag46,
            },
        );
        sourceFile10.push(
            {
                key:  '企业注册登记证件',
                title: '企业注册登记证件',
                description: '企业注册登记证件',
                disabled: !this.state.flag1,
            },
            {
                key:  '技术领域说明',
                title: '技术领域说明',
                description: '技术领域说明',
                disabled: !this.state.flag2,
            },
            {
                key:  '知识产权未重复使用声明',
                title: '知识产权未重复使用声明',
                description: '知识产权未重复使用声明',
                disabled: !this.state.flag3,
            },
            {
                key:  '知识产权情况汇总表',
                title: '知识产权情况汇总表',
                description: '知识产权情况汇总表',
                disabled: !this.state.flag4,
            },
            {
                key:  '知识产权概况',
                title: '知识产权概况',
                description: '知识产权概况',
                disabled: !this.state.flag5,
            },
            {
                key:  '知识产权证明材料',
                title: '知识产权证明材料',
                description: '知识产权证明材料',
                disabled: !this.state.flag6,
            },
            {
                key:  '知识产权对主要产品（服务）在技术上发挥核心支持作用介绍',
                title: '知识产权对主要产品（服务）在技术上发挥核心支持作用介绍',
                description: '知识产权对主要产品（服务）在技术上发挥核心支持作用介绍',
                disabled: !this.state.flag7,
            },
            {
                key:  '研发费用专项审计报告',
                title: '研发费用专项审计报告',
                description: '研发费用专项审计报告',
                disabled: !this.state.flag8,
            },
            {
                key:  '高品专项审计报告',
                title: '高品专项审计报告',
                description: '高品专项审计报告',
                disabled: !this.state.flag9,
            },
            {
                key:  '财务审计报告',
                title: '财务审计报告',
                description: '财务审计报告',
                disabled: !this.state.flag10,
            },
            {
                key:  '纳税申报表',
                title: '纳税申报表',
                description: '纳税申报表',
                disabled: !this.state.flag11,
            },
            {
                key:  '中介证明',
                title: '中介证明',
                description: '中介证明',
                disabled: !this.state.flag12,
            },
            {
                key:  '其他材料',
                title: '其他材料',
                description: '其他材料',
                disabled: !this.state.flag13,
            },
            {
                key:  '近三年成果转化汇总表',
                title: '近三年成果转化汇总表',
                description: '近三年成果转化汇总表',
                disabled: !this.state.flag14,
            },
            {
                key:  '科技成果转化总体情况说明',
                title: '科技成果转化总体情况说明',
                description: '科技成果转化总体情况说明',
                disabled: !this.state.flag15,
            },
            {
                key:  '科技成果逐项说明',
                title: '科技成果逐项说明',
                description: '科技成果逐项说明',
                disabled: !this.state.flag16,
            },
            {
                key:  '成果转化证明材料',
                title: '成果转化证明材料',
                description: '成果转化证明材料',
                disabled: !this.state.flag17,
            },
            {
                key:  '项目立项汇总表',
                title: '项目立项汇总表',
                description: '项目立项汇总表',
                disabled: !this.state.flag18,
            },
            {
                key:  '立项决议',
                title: '立项决议',
                description: '立项决议',
                disabled: !this.state.flag19,
            },
            {
                key:  '项目研究开发设计书',
                title: '项目研究开发设计书',
                description: '项目研究开发设计书',
                disabled: !this.state.flag20,
            },
            {
                key:  '项目验收报告',
                title: '项目验收报告',
                description: '项目验收报告',
                disabled: !this.state.flag21,
            },
            {
                key:  '人员情况表',
                title: '人员情况表',
                description: '人员情况表',
                disabled: !this.state.flag22,
            },
            {
                key:  '人员花名册',
                title: '人员花名册',
                description: '人员花名册',
                disabled: !this.state.flag23,
            },
            {
                key:  '人员结构表',
                title: '人员结构表',
                description: '人员结构表',
                disabled: !this.state.flag24,
            },
            {
                key:  '社保缴费证明',
                title: '社保缴费证明',
                description: '社保缴费证明',
                disabled: !this.state.flag25,
            },
            {
                key:  '高新技术产品关键技术和技术指标的具体说明',
                title: '高新技术产品关键技术和技术指标的具体说明',
                description: '高新技术产品关键技术和技术指标的具体说明',
                disabled: !this.state.flag26,
            },
            {
                key:  '高品证明材料',
                title: '高品证明材料',
                description: '高品证明材料',
                disabled: !this.state.flag27,
            },
            {
                key:  '企业研究开发组织管理水平总体情况说明',
                title: '企业研究开发组织管理水平总体情况说明',
                description: '企业研究开发组织管理水平总体情况说明',
                disabled: !this.state.flag28,
            },
            {
                key:  '企业研究开发组织管理水平指标逐项说明',
                title: '企业研究开发组织管理水平指标逐项说明',
                description: '企业研究开发组织管理水平指标逐项说明',
                disabled: !this.state.flag29,
            },
            {
                key:  '研发项目管理制度',
                title: '研发项目管理制度',
                description: '研发项目管理制度',
                disabled: !this.state.flag30,
            },
            {
                key:  '研发投入核算管理制度',
                title: '研发投入核算管理制度',
                description: '研发投入核算管理制度',
                disabled: !this.state.flag31,
            },
            {
                key:  '研发辅助账管理办法',
                title: '研发辅助账管理办法',
                description: '研发辅助账管理办法',
                disabled: !this.state.flag32,
            },
            {
                key:  '企业研发准备金管理制度',
                title: '企业研发准备金管理制度',
                description: '企业研发准备金管理制度',
                disabled: !this.state.flag33,
            },
            {
                key:  '成立研发中心的通知',
                title: '成立研发中心的通知',
                description: '成立研发中心的通知',
                disabled: !this.state.flag34,
            },
            {
                key:  '研发中心建设情况说明',
                title: '研发中心建设情况说明',
                description: '研发中心建设情况说明',
                disabled: !this.state.flag35,
            },
            {
                key:  '研发设备明细表',
                title: '研发设备明细表',
                description: '研发设备明细表',
                disabled: !this.state.flag36,
            },
            {
                key:  '产学研协议',
                title: '产学研协议',
                description: '产学研协议',
                disabled: !this.state.flag37,
            },
            {
                key:  '科技成果转化的组织实施与激励奖励制度',
                title: '科技成果转化的组织实施与激励奖励制度',
                description: '科技成果转化的组织实施与激励奖励制度',
                disabled: !this.state.flag38,
            },
            {
                key:  '开放式创新创业平台制度',
                title: '开放式创新创业平台制度',
                description: '开放式创新创业平台制度',
                disabled: !this.state.flag39,
            },
            {
                key:  '科技人员培训管理制度',
                title: '科技人员培训管理制度',
                description: '科技人员培训管理制度',
                disabled: !this.state.flag40,
            },
            {
                key:  '科技人员培养进修制度',
                title: '科技人员培养进修制度',
                description: '科技人员培养进修制度',
                disabled: !this.state.flag41,
            },
            {
                key:  '人才引进制度',
                title: '人才引进制度',
                description: '人才引进制度',
                disabled: !this.state.flag42,
            },
            {
                key:  '研发人员绩效考核制度',
                title: '研发人员绩效考核制度',
                description: '研发人员绩效考核制度',
                disabled: !this.state.flag43,
            },
            {
                key:  '研发设备照片',
                title: '研发设备照片',
                description: '研发设备照片',
                disabled: !this.state.flag44,
            },
            {
                key:  '研发费用辅助帐',
                title: '研发费用辅助帐',
                description: '研发费用辅助帐',
                disabled: !this.state.flag45,
            },
            {
                key:  '荣誉资质',
                title: '荣誉资质',
                description: '荣誉资质',
                disabled: !this.state.flag46,
            },
        );
        return (
            <div>
                <Anchor id="downloadDiv" style={{display: 'none'}}/>
                <div className="content-page-header">
                    <PageHeader
                        ghost={false}
                        title="文件合成"
                        subTitle='请在左侧选择已生成或者上传的文件,点击箭头添加至右侧，进行文件的合并下载;该地区没有或者未生成的文件不可选。'
                    >
                    </PageHeader>
                </div>
                <div>
                    <Paragraph>
                        <pre>注：按顺序生成时，请在左侧按顺序选择要生成的文件一起添加至右侧，系统将按照右侧自上而下的顺序合并文件。</pre>
                    </Paragraph>
                </div>
                <div>
                    <Space direction="vertical" className="content-style">
                        <Card
                            size="small"
                            title="资质证明"
                            bordered={true}
                            style={{border:'solid  1px #7F9DB9'}}
                            extra={
                                <Button onClick={this.handleExport1.bind(this)} type={"primary"}>生成并下载
                                </Button>
                            }
                        >
                            {
                                this.state.loading1 === false?
                                    <Transfer
                                        oneWay
                                        dataSource={sourceFile1}
                                        titles={['待选择文件', '待合成文件']}
                                        targetKeys={this.state.targetKeys1}
                                        selectedKeys={this.state.selectedKeys1}
                                        onChange={this.handleChange1.bind(this)}
                                        onSelectChange={this.handleSelectChange1.bind(this)}
                                        render={item => item.title}
                                        listStyle={{
                                            width: 500,
                                            height: 200,
                                        }}
                                    />:
                                    <Spin tip={"合并生成中..."}/>
                            }
                        </Card>
                        <Card
                            size="small"
                            title="知识产权"
                            bordered={true}
                            style={{border:'solid  1px #7F9DB9'}}
                            extra={<Button onClick={this.handleExport2.bind(this)} type={"primary"}>生成并下载</Button>}
                        >
                            {
                                this.state.loading2 === false?
                                    <Transfer
                                        listStyle={{
                                            width: 500,
                                            height: 200,
                                        }}
                                        oneWay
                                        dataSource={sourceFile2}
                                        titles={['待选择文件', '待合成文件']}
                                        targetKeys={this.state.targetKeys2}
                                        selectedKeys={this.state.selectedKeys2}
                                        onChange={this.handleChange2.bind(this)}
                                        onSelectChange={this.handleSelectChange2.bind(this)}
                                        render={item => item.title}
                                    />:
                                    <Spin tip={"合并生成中..."}/>
                            }
                        </Card>
                        <Card
                            size="small"
                            title="审计报告"
                            bordered={true}
                            style={{border:'solid  1px #7F9DB9'}}
                            extra={<Button onClick={this.handleExport3.bind(this)} type={"primary"}>生成并下载</Button>}
                        >
                            {
                                this.state.loading3 === false?
                                    <Transfer
                                        listStyle={{
                                            width: 500,
                                            height: 200,
                                        }}
                                        oneWay
                                        dataSource={sourceFile3}
                                        titles={['待选择文件', '待合成文件']}
                                        targetKeys={this.state.targetKeys3}
                                        selectedKeys={this.state.selectedKeys3}
                                        onChange={this.handleChange3.bind(this)}
                                        onSelectChange={this.handleSelectChange3.bind(this)}
                                        render={item => item.title}
                                    />:
                                    <Spin tip={"合并生成中..."}/>
                            }
                        </Card>
                        <Card
                            size="small"
                            title="成果转化"
                            bordered={true}
                            style={{border:'solid  1px #7F9DB9'}}
                            extra={<Button onClick={this.handleExport4.bind(this)} type={"primary"}>生成并下载</Button>}
                        >
                            {
                                this.state.loading4 === false?
                                    <Transfer
                                        listStyle={{
                                            width: 500,
                                            height: 200,
                                        }}
                                        oneWay
                                        dataSource={sourceFile4}
                                        titles={['待选择文件', '待合成文件']}
                                        targetKeys={this.state.targetKeys4}
                                        selectedKeys={this.state.selectedKeys4}
                                        onChange={this.handleChange4.bind(this)}
                                        onSelectChange={this.handleSelectChange4.bind(this)}
                                        render={item => item.title}
                                    />:
                                    <Spin tip={"合并生成中..."}/>
                            }
                        </Card>
                        <Card
                            size="small"
                            title="立项"
                            bordered={true}
                            style={{border:'solid  1px #7F9DB9'}}
                            extra={<Button onClick={this.handleExport5.bind(this)} type={"primary"}>生成并下载</Button>}
                        >
                            {
                                this.state.loading5 === false?
                                    <Transfer
                                        listStyle={{
                                            width: 500,
                                            height: 200,
                                        }}
                                        oneWay
                                        dataSource={sourceFile5}
                                        titles={['待选择文件', '待合成文件']}
                                        targetKeys={this.state.targetKeys5}
                                        selectedKeys={this.state.selectedKeys5}
                                        onChange={this.handleChange5.bind(this)}
                                        onSelectChange={this.handleSelectChange5.bind(this)}
                                        render={item => item.title}
                                    />:
                                    <Spin tip={"合并生成中..."}/>
                            }
                        </Card>
                        <Card
                            size="small"
                            title="人员"
                            bordered={true}
                            style={{border:'solid  1px #7F9DB9'}}
                            extra={<Button onClick={this.handleExport6.bind(this)} type={"primary"}>生成并下载</Button>}
                        >
                            {
                                this.state.loading6 === false?
                                    <Transfer
                                        listStyle={{
                                            width: 500,
                                            height: 200,
                                        }}
                                        oneWay
                                        dataSource={sourceFile6}
                                        titles={['待选择文件', '待合成文件']}
                                        targetKeys={this.state.targetKeys6}
                                        selectedKeys={this.state.selectedKeys6}
                                        onChange={this.handleChange6.bind(this)}
                                        onSelectChange={this.handleSelectChange6.bind(this)}
                                        render={item => item.title}
                                    />:
                                    <Spin tip={"合并生成中..."}/>
                            }
                        </Card>
                        <Card
                            size="small"
                            title="高品"
                            bordered={true}
                            style={{border:'solid  1px #7F9DB9'}}
                            extra={<Button onClick={this.handleExport7.bind(this)} type={"primary"}>生成并下载</Button>}
                        >
                            {
                                this.state.loading7 === false?
                                    <Transfer
                                        listStyle={{
                                            width: 500,
                                            height: 200,
                                        }}
                                        oneWay
                                        dataSource={sourceFile7}
                                        titles={['待选择文件', '待合成文件']}
                                        targetKeys={this.state.targetKeys7}
                                        selectedKeys={this.state.selectedKeys7}
                                        onChange={this.handleChange7.bind(this)}
                                        onSelectChange={this.handleSelectChange7.bind(this)}
                                        render={item => item.title}
                                    />:
                                    <Spin tip={"合并生成中..."}/>
                            }
                        </Card>
                        <Card
                            size="small"
                            title="组织管理"
                            bordered={true}
                            style={{border:'solid  1px #7F9DB9'}}
                            extra={<Button onClick={this.handleExport8.bind(this)} type={"primary"}>生成并下载</Button>}
                        >
                            {
                                this.state.loading8 === false?
                                    <Transfer
                                        listStyle={{
                                            width: 500,
                                            height: 200,
                                        }}
                                        oneWay
                                        dataSource={sourceFile8}
                                        titles={['待选择文件', '待合成文件']}
                                        targetKeys={this.state.targetKeys8}
                                        selectedKeys={this.state.selectedKeys8}
                                        onChange={this.handleChange8.bind(this)}
                                        onSelectChange={this.handleSelectChange8.bind(this)}
                                        render={item => item.title}
                                    />:
                                    <Spin tip={"合并生成中..."}/>
                            }
                        </Card>
                        <Card
                            size="small"
                            title="荣誉资质"
                            bordered={true}
                            style={{border:'solid  1px #7F9DB9'}}
                            extra={<Button onClick={this.handleExport9.bind(this)} type={"primary"}>生成并下载</Button>}
                        >
                            {
                                this.state.loading9 === false?
                                    <Transfer
                                        listStyle={{
                                            width: 500,
                                            height: 200,
                                        }}
                                        oneWay
                                        dataSource={sourceFile9}
                                        titles={['待选择文件', '待合成文件']}
                                        targetKeys={this.state.targetKeys9}
                                        selectedKeys={this.state.selectedKeys9}
                                        onChange={this.handleChange9.bind(this)}
                                        onSelectChange={this.handleSelectChange9.bind(this)}
                                        render={item => item.title}
                                    />:
                                    <Spin tip={"合并生成中..."}/>
                            }
                        </Card>
                        <Card
                            size="small"
                            title="全部文件"
                            bordered={true}
                            style={{border:'solid  1px #7F9DB9'}}
                            extra={<Button onClick={this.handleExport10.bind(this)} type={"primary"}>生成并下载</Button>}
                        >
                            {
                                this.state.loading10 === false?
                                    <Transfer
                                        listStyle={{
                                            width: 500,
                                            height: 500,
                                        }}
                                        oneWay
                                        dataSource={sourceFile10}
                                        titles={['待选择文件', '待合成文件']}
                                        targetKeys={this.state.targetKeys10}
                                        selectedKeys={this.state.selectedKeys10}
                                        onChange={this.handleChange10.bind(this)}
                                        onSelectChange={this.handleSelectChange10.bind(this)}
                                        render={item => item.title}
                                    />:
                                    <Spin tip={"合并生成中..."}/>
                            }
                        </Card>
                    </Space>
                </div>
            </div>
        )
    }
}

export default FinallyFile;